import React, { useMemo } from 'react'
import { Route, useParams } from 'react-router-dom'
import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'

import Card from './Card'
import ReplaceTV, { ReplaceResume, ReplaceChromecast } from './Actions/Replace'
import Checkout from './Actions/Checkout'
import RebootModal from './Actions/Reboot'
import Config, { ConfigChromecast } from './Actions/Config'
import StreamCast from './StreamCast'
import { useRoom } from './use-rooms'

const SetupContainer = () => {
  const {deviceId} = useParams()
  
  const room = useRoom()
  const device = useMemo(() => room && room.devices.find(device => device.uuid === deviceId), [room, deviceId])
  
  if (!device) {
    return null
  }
  if (device.kind === 'chromecast') {
    return <ConfigChromecast device={device} />
  }
  return (
    <Config device={device} />
  )
}
const RoomRoute = ({path}) => { return [
  <Route path={path} key="streamcast-card" element={<Card />}>
    <Route
      path="checkout"
      key="streamcast-card-checkout"
      element={<Checkout />}
    />
    <Route
      path=":deviceId/setup"
      key="streamcast-card-setup"
      element={<SetupContainer />}
    />
    <Route
      path=":deviceId/replace_tv_resume"
      key="streamcast-card-replace_resume"
      element={<ReplaceResume kind="tv" />}
    />
    <Route
      path=":deviceId/replace_tv"
      key="streamcast-card-replace-tv"
      element={<ReplaceTV />}
    />
    <Route
      path=":deviceId/replace_chromecast"
      key="streamcast-card-replace-chromecast"
      element={<ReplaceChromecast />}
    />
    <Route
      path=":deviceId/replace_chromecast_resume"
      key="streamcast-card-replace-chromecast_resume"
      element={<ReplaceResume kind="chromecast" />}
    />
    <Route
      path=":deviceId/reboot"
      key="streamcast-card-reboot"
      element={<RebootModal />}
    />
  </Route>
]}

export const StreamCastRoutes = ({
  path = '/stream-cast',
}) => [
  <Route
    path={path}
    key="streamcast"
    element={
      <RouteGuard requiredRoles={['stream_cast']}>
        <StreamCast />
      </RouteGuard>
    }
  >
    {RoomRoute({path: ':siteId/room/:id'})}
    {RoomRoute({ path: 'room/:id' })}
  </Route>
]

export default StreamCastRoutes